export default __webpack_public_path__ + "static/media/home-photo-cut.6f5ee48d.jpg";